// extracted by mini-css-extract-plugin
module.exports = {"invoiceInput":"VoucherGroupList_invoiceInput__FgxoX","tableRow":"VoucherGroupList_tableRow__3KFrM","action":"VoucherGroupList_action__1ZLp0"};